import styled from "styled-components";
import { Link } from "react-router-dom";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const CardWrapperLink = styled(Link)<{ isLastBlogPost: boolean }>`
  display: grid;
  width: 256px;
  height: 275px;

  margin-right: 16px;
  background-color: ${colors.white};

  ${breakpoints.xxsDown} {
    margin-right: 12px;
  }

  ${(props) => props.isLastBlogPost && "margin-right: 0px"};
`;

export const CardImage = styled.img<{ src: string | undefined }>`
  background-color: transparent;
  width: 256px;
  height: 169px;
  object-fit: cover;
`;

export const CardBottomPanel = styled.div`
  border: 1.2px solid ${colors.black};
  width: 256px;
  height: 105px;
  border-top: 0px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const PostTitle = styled.div`
  font-family: ${fonts.fontBauMedium};
  font-size: 11px;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
  margin-bottom: 12px;
`;

export const RecipeTitle = styled.div`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 22px;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 30px;

  ${breakpoints.smDown} {
    font-size: 18px;
    line-height: 18px;
    height: 26px;
  }
`;

export const RecipeTypeAndReadingTime = styled.div`
  font-family: ${fonts.fontBauRegular};
  font-size: 12px;
  line-height: 16px;

  &:first-letter {
    text-transform: capitalize;
  }
`;

export const CardHeaderWrapper = styled.div`
  position: relative;
  height: 169px;
  width: 100%;
`;
